
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return require("private-next-pages/[...slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...slug]"])
      });
    }
  